import { render, staticRenderFns } from "./associationDynamic.vue?vue&type=template&id=2453b419"
import script from "./associationDynamic.vue?vue&type=script&lang=js"
export * from "./associationDynamic.vue?vue&type=script&lang=js"
import style0 from "./associationDynamic.vue?vue&type=style&index=0&id=2453b419&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports